/**
 * Reads a theme CSS custom property's resolved value off <html>, e.g. `'--color-surface'` → `'#ffffff'`.
 *
 * For JavaScript that must hand concrete colors to a library (Mermaid, React Flow, canvas). The
 * palette switches with `data-theme` on <html>, so callers re-read when the theme changes (pass
 * next-themes' `resolvedTheme` as an effect dependency). Never hardcode the hex instead.
 */
export function readThemeColor(name: `--${string}`, fallback: string): string {
  if (typeof document === 'undefined') return fallback;
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
}
